export default __webpack_public_path__ + "static/media/Nergal's Scimiter of the Burning Sky.cd9e0434.jpg";